// extracted by mini-css-extract-plugin
module.exports = {"form":"ModelConfigurationPopup_form__2xozp"};